import React, { Component } from 'react'
import CommonTableModule from './../CommonTable/CommonTableModule';
import { Card, Alert, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import CommonLoader from '../loaderComponent/CommonLoader';
import { hasPermission } from '../../utils/usePermission';

export default class PermissionCodeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissionData: [],
      loading: true,
      hasError: false,
      errMsg: "",
    };

  }



  async componentDidMount() {
    this.fetchPermissionCodes();
  }

  fetchPermissionCodes = async () => {
    this.setState({ loading: true });

    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({
        hasError: true,
        errMsg: "Unauthorized! Please log in.",
        loading: false
      });
      return;
    }

    const headers = { Authorization: `Bearer ${token}` };


    try {
      const response = await axios.get("/permission", {
        headers
      });

      this.setState({ permissionData: response?.data, loading: false });
    } catch (error) {
      console.error("Error fetching permission code:", error);
      let errorMessage = "Failed to load permission code.";
      if (error.response?.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  };


  // async componentDidMount() {
  //   this.setState({ loading: true })
  //   const token = localStorage.getItem("token");
  //   if (!token) {
  //     this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
  //     return;
  //   }
  //   const headers = { Authorization: `Bearer ${token}` };
  //   try {
  //     const response = await axios.get('/permission', { headers });
  //     this.setState({ permissionData: response?.data });
  //     setTimeout(() => {
  //       this.setState({ loading: false });
  //     }, 900);
  //   } catch (error) {
  //     console.error("Error fetching permission code:", error);
  //     let errorMessage = "Failed to load permission code.";

  //     if (error.response && error.response.status === 403) {
  //       errorMessage = "Access Denied! Admin privileges required.";
  //     }
  //     this.setState({ hasError: true, errMsg: errorMessage, loading: false });
  //   }
  // }
  onEditPermissionCode = (data) => {
    if (!data) {
      console.error("No rowData provided!");
      return;
    }
    this.props.history.push({
      pathname: `/permission-code-edit/${data.id}`,
      state: { data }
    });
  }

  handleAddPermissionCode = () => {
    this.props.history.push('/permission-code-add')
  }
  render() {
    const columns = [
      { key: "id", label: "ID" },
      { key: "code", label: "Code" },
      { key: "name", label: "Description" },

      {
        key: "actions",
        label: "Action",
        render: (value, rowData) => {
          return (
            <>
              {hasPermission('M2S2B2') && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`tooltip-edit-${rowData?.id || "default"}`}>Edit Permission Code</Tooltip>}
                >
                  <Button
                    size="sm"
                    variant="outline-info"
                    className="mr-2 info"
                    onClick={() => this.onEditPermissionCode(rowData)}
                  >
                    <i className="fa fa-edit"></i>
                  </Button>
                </OverlayTrigger>
              )}
            </>
          );
        }
      },
    ];
    return (
      <div className="container-fluid pt-4">
        <div className='d-flex search-btn-gap'>


        </div>
        <CommonLoader isLoading={this.state.loading}>
          {
            hasPermission('M2S2B1') && (
              <div className='add-role'>
                <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleAddPermissionCode}> <i className="fa fa-plus-circle"></i> Add Permission Code</Button>
              </div>
            )
          }
          <Card className="mb-3">
            <Card.Header>
              <b>Permission Code List</b>
            </Card.Header>
            <Card.Body>
              {this.state.hasError ? (
                <Alert variant="outline-danger" className="m-3">
                  {this.state.errMsg}
                </Alert>
              ) : (
                <CommonTableModule columns={columns} data={this.state.permissionData} />
              )}
            </Card.Body>
          </Card>
        </CommonLoader>
      </div>
    )
  }
}
